module.exports = __webpack_public_path__ + "static/doctor-01-f18b142412b813d3383fea7338c300a1.png";